export const Security = Object.freeze({
    SET_LOADING: "security.set_loading",
    SET_BANS: "security.set_bans",
    SET_ALLOWLIST: "security.set_allowlist",
    SET_ERROR: "security.set_error",
});
